import { render, staticRenderFns } from "./_base-modal.vue?vue&type=template&id=23e2ee83"
import script from "./_base-modal.vue?vue&type=script&lang=js"
export * from "./_base-modal.vue?vue&type=script&lang=js"
import style0 from "./_base-modal.vue?vue&type=style&index=0&id=23e2ee83&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports